import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

// Import Logo
import logodark from "../../assets/images/seri dark.png";

class PrivacyPolicy extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const lastUpdated = "31 de agosto de 2026";

    return (
      <React.Fragment>
        <section className="section bg-light" style={{ paddingTop: "120px" }} id="privacy">
          <Container>
            <Row className="justify-content-center">
              <Col lg={9}>
                <div className="text-center mb-5">
                  <Link to="/">
                    <img src={logodark} alt="SERI S.A.S" height="50" />
                  </Link>
                  <h1 className="mt-4">Política de Privacidad</h1>
                  <p className="text-muted mb-0">
                    Uso de las APIs de Meta (Facebook e Instagram)
                  </p>
                  <p className="text-muted f-14">
                    Última actualización: {lastUpdated}
                  </p>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col lg={9}>
                <div className="privacy-content text-muted">
                  <h4 className="mb-3">1. Introducción</h4>
                  <p>
                    SERI S.A.S ("SERI", "nosotros" o "la Empresa"), con domicilio
                    en Carrera 74 B 92 46 AP 201, Medellín, Antioquia, Colombia,
                    respeta su privacidad y se compromete a proteger los datos
                    personales que trata. Esta Política de Privacidad describe
                    cómo recopilamos, usamos, almacenamos y protegemos la
                    información obtenida a través de nuestras aplicaciones y
                    servicios que utilizan las APIs de Meta Platforms, Inc.
                    (Facebook Login, Graph API, Instagram Graph API y APIs
                    relacionadas de WhatsApp y Messenger).
                  </p>

                  <h4 className="mb-3 mt-4">2. Responsable del tratamiento</h4>
                  <p>
                    El responsable del tratamiento de los datos es SERI S.A.S.
                    Para cualquier consulta relacionada con esta política o con el
                    tratamiento de sus datos, puede contactarnos en{" "}
                    <a href="mailto:serisas.admon@gmail.com">
                      serisas.admon@gmail.com
                    </a>
                    .
                  </p>

                  <h4 className="mb-3 mt-4">3. Información que recopilamos</h4>
                  <p>
                    Cuando usted utiliza nuestras aplicaciones e inicia sesión o
                    conecta sus cuentas de Meta, podemos acceder y recopilar,
                    únicamente con su autorización expresa y según los permisos
                    que usted conceda, la siguiente información:
                  </p>
                  <ul>
                    <li>
                      Datos de perfil público de Facebook o Instagram: nombre,
                      identificador de usuario, foto de perfil y dirección de
                      correo electrónico.
                    </li>
                    <li>
                      Información de páginas y cuentas profesionales que usted
                      administre (nombre de la página, identificador, métricas y
                      contenido publicado).
                    </li>
                    <li>
                      Contenido y mensajes de las plataformas de Meta (por
                      ejemplo, comentarios, publicaciones o conversaciones de
                      Messenger/WhatsApp) cuando la funcionalidad contratada así
                      lo requiera.
                    </li>
                    <li>
                      Tokens de acceso necesarios para mantener la conexión con
                      las APIs de Meta.
                    </li>
                  </ul>
                  <p>
                    Solo solicitamos los permisos estrictamente necesarios para
                    prestar el servicio y nunca recopilamos información sin su
                    consentimiento.
                  </p>

                  <h4 className="mb-3 mt-4">4. Uso de la información</h4>
                  <p>Utilizamos la información recopilada para:</p>
                  <ul>
                    <li>Autenticar y permitir el acceso a nuestras aplicaciones.</li>
                    <li>
                      Prestar los servicios contratados (gestión de redes
                      sociales, automatización de mensajes, analítica y reportes).
                    </li>
                    <li>
                      Mostrar y administrar el contenido de sus páginas y cuentas
                      conectadas.
                    </li>
                    <li>Mejorar y mantener la seguridad de nuestros servicios.</li>
                    <li>Cumplir con obligaciones legales aplicables.</li>
                  </ul>
                  <p>
                    No vendemos, alquilamos ni comercializamos su información
                    personal a terceros.
                  </p>

                  <h4 className="mb-3 mt-4">
                    5. Compartición de información con terceros
                  </h4>
                  <p>
                    Podemos compartir información únicamente en los siguientes
                    casos: (i) con proveedores de servicios que actúan por cuenta
                    nuestra bajo obligaciones de confidencialidad; (ii) cuando sea
                    requerido por una autoridad competente o por ley; y (iii) con
                    Meta, en la medida necesaria para el funcionamiento de sus
                    APIs. Cualquier tratamiento se realiza conforme a las{" "}
                    <a
                      href="https://developers.facebook.com/terms/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Políticas para Desarrolladores de Meta
                    </a>
                    .
                  </p>

                  <h4 className="mb-3 mt-4">6. Almacenamiento y seguridad</h4>
                  <p>
                    Almacenamos la información en servidores seguros y aplicamos
                    medidas técnicas y organizativas razonables para protegerla
                    contra el acceso no autorizado, la pérdida o la alteración.
                    Los tokens de acceso se almacenan cifrados y se conservan solo
                    durante el tiempo necesario para prestar el servicio.
                  </p>

                  <h4 className="mb-3 mt-4">7. Conservación de los datos</h4>
                  <p>
                    Conservamos sus datos personales únicamente durante el tiempo
                    necesario para cumplir con las finalidades descritas en esta
                    política, o hasta que usted solicite su eliminación o revoque
                    los permisos otorgados a través de la configuración de su
                    cuenta de Meta.
                  </p>

                  <h4 className="mb-3 mt-4">
                    8. Eliminación de datos y revocación de permisos
                  </h4>
                  <p>
                    Usted puede revocar en cualquier momento el acceso de nuestra
                    aplicación desde la configuración de su cuenta de Facebook o
                    Instagram (Configuración → Apps y sitios web).
                  </p>
                  <p>
                    Para solicitar la eliminación de los datos que hayamos
                    almacenado, envíe una solicitud a{" "}
                    <a href="mailto:serisas.admon@gmail.com">
                      serisas.admon@gmail.com
                    </a>{" "}
                    con el asunto "Eliminación de datos". Procesaremos su solicitud
                    y eliminaremos la información asociada dentro de un plazo
                    máximo de 30 días, salvo que exista una obligación legal de
                    conservarla.
                  </p>

                  <h4 className="mb-3 mt-4">9. Sus derechos</h4>
                  <p>
                    De conformidad con la Ley 1581 de 2012 de Colombia y demás
                    normativa aplicable, usted tiene derecho a conocer, actualizar,
                    rectificar y suprimir sus datos personales, así como a revocar
                    la autorización otorgada. Puede ejercer estos derechos
                    escribiéndonos a{" "}
                    <a href="mailto:serisas.admon@gmail.com">
                      serisas.admon@gmail.com
                    </a>
                    .
                  </p>

                  <h4 className="mb-3 mt-4">10. Cambios en esta política</h4>
                  <p>
                    Podemos actualizar esta Política de Privacidad ocasionalmente.
                    Publicaremos cualquier cambio en esta página e indicaremos la
                    fecha de la última actualización en la parte superior.
                  </p>

                  <h4 className="mb-3 mt-4">11. Contacto</h4>
                  <p className="mb-0">
                    SERI S.A.S
                    <br />
                    Carrera 74 B 92 46 AP 201, Medellín, Antioquia, Colombia
                    <br />
                    Correo:{" "}
                    <a href="mailto:serisas.admon@gmail.com">
                      serisas.admon@gmail.com
                    </a>
                    <br />
                    Teléfono:{" "}
                    <a href="tel:+573005747246">+57 300 574 7246</a>
                  </p>

                  <div className="mt-5">
                    <Link to="/" className="btn btn-primary">
                      Volver al inicio
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default PrivacyPolicy;
